import { render, staticRenderFns } from "./RadioSize.vue?vue&type=template&id=0c67a2a1"
import script from "./RadioSize.vue?vue&type=script&lang=js"
export * from "./RadioSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports